export default "/images/MBE.png?d481ef251d15344f6a2555c49dc768a2";